import { CALL_API, METHOD_TYPE } from '../../middleware/api.middleware'

export const MERGE_CONTACT_REQUEST = 'MERGE_CONTACTS_REQUEST'
export const MERGE_CONTACT_SUCCESS = 'MERGE_CONTACTS_SUCCESS'
export const MERGE_CONTACT_FAILURE = 'MERGE_CONTACTS_FAILURE'

/**
 * Merge Contact
 * @param params.id
 * @param params.masterId - contact to merge into
 * @param options
 * @returns {{}}
 */
export const _mergeContact = (params, options = {}) => ({
  [CALL_API]: {
    types: options.types || [
      MERGE_CONTACT_REQUEST,
      MERGE_CONTACT_SUCCESS,
      MERGE_CONTACT_FAILURE
    ],
    method: METHOD_TYPE.PUT,
    endpoint: `/contact/${params.masterId}/merge/${params.id}`,
    payload: params
  }
})

/**
 * Dispatch MERGE_CONTACTS_REQUEST
 * @param params.id
 * @param params.masterId - contact to merge into
 * @param options.types - action types
 */
export const mergeContact = (params, options) => (dispatch) => {
  return dispatch(_mergeContact(params, options))
}
